import { Environment } from '../../../enums';

import { getApiBaseUrl } from './getApiBaseUrl';
import { getLegacyBaseUrl } from './getLegacyBaseUrl';

const getOriginFromBaseUrl = (baseUrl: string): string => {
    try {
        const url = new URL(baseUrl);
        return url.origin;
    } catch (error) {
        console.error(`Invalid baseUrl: ${baseUrl}`);
        return '';
    }
};

export const inferEnvironmentFromBaseUrl = (baseUrl: string | undefined): Environment => {
    if (baseUrl) {
        for (const env of Object.values(Environment)) {
            if (
                baseUrl.startsWith(getOriginFromBaseUrl(getApiBaseUrl(env))) ||
                baseUrl.startsWith(getOriginFromBaseUrl(getLegacyBaseUrl(env)))
            ) {
                return env;
            }
        }
    }
    return Environment.PROD;
};
